import {call, put, takeLatest} from 'redux-saga/effects';
import {base_url, endpoints} from '../../../constants';
import {AxiosService} from '../../../services';
import {actionTypes} from '../../../types';
import {userLoginFailure, userLoginSuccess} from "../../actions/authActions/userLoginActions";
import {setSessonToken} from "../../../publicStore/actions/utilsActions/utilsActions";

function* userLogin({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.userLogin,
            payload: payload,
            isAuth: false,
        });
        console.log('====================================');
        console.log("USER_LOGIN_SUCCESS status :", response.data.status);
        console.log("USER_LOGIN_SUCCESS data :", response.data.response);
        console.log("USER_LOGIN_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            userLoginSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        yield put(setSessonToken(response?.data?.response));
    } catch (error) {
        console.log('====================================');
        console.log("USER_LOGIN_FAILURE status :", error?.response?.status);
        console.log("USER_LOGIN_FAILURE data:", error?.response?.data);
        console.log("USER_LOGIN_FAILURE error :", error);
        console.log('====================================');
        yield put(userLoginFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* userLoginSaga() {
    yield takeLatest(actionTypes.USER_LOGIN_REQUEST, userLogin);
}

export default userLoginSaga;
